<ion-item class="purchase-data-block">

  <ion-label>
    <div class="data">
      <yu-icon slot="start" name="hash"></yu-icon>
      <span>{{ reference }}</span>
    </div>

    <div class="data" (click)="openModalDate()">
      <yu-icon slot="start" name="calendar"></yu-icon>
      <span>{{ date | date: "dd/MM/yyyy HH:mm" }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="map-pin"></yu-icon>
      <span>{{ local }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="suitcase-simple"></yu-icon>
      <span>{{ provider }}</span>
    </div>

    <ng-content select="[extra-data]"></ng-content>

  </ion-label>

  <ion-note slot="end">
    <yu-tag [color]="colorState">{{ state }}</yu-tag>
  </ion-note>

</ion-item>
